<div class="flex-content">
  <app-favorites #appFavorites [editFavorites]="editFavorites"></app-favorites>
</div>
<!--Footer-->
<div class="flex-footer" *ngIf="editFavorites">
  <div class="flex-footer-left">
    <tyl-button image="Expand All.png" label="Expand All" (clickEvent)="expandAllClick(true)"></tyl-button>
    <tyl-button image="Collapse All.png" label="Collapse All" (clickEvent)="expandAllClick(false)"></tyl-button>
  </div>
  <div class="flex-footer-right">
    <tyl-button image="Save.png" label="Save" (clickEvent)="saveClick()"></tyl-button>
    <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
  </div>
</div>
